/* eslint-disable no-param-reassign,no-restricted-syntax */

// HACK: This is coupled with the config of our thumbnail generating lambda
const noThumbnailBlacklist = [
  '/originals/legos/fusebox-diagrams',
  '/originals/legos/fusebox-tables',
  '/originals/legos/fusebox-pictures',
  '/originals/manual-screenshots',
];

// This works for the "new" thumbnail generating lambda; images as attachments for defectos have a different pattern
// See model/attachment.js
export function getImageThumbnail(imgUrl, size, options = { skipCloudfront: false }) {
  imgUrl = imgUrl || '';
  for (const excludedPattern of noThumbnailBlacklist) {
    if (imgUrl.includes(excludedPattern)) {
      return imgUrl;
    }
  }

  if (imgUrl.includes('/originals/cerokm/spec/')) {
    imgUrl = imgUrl.replace('.png', '.avif');
  } else {
    if (imgUrl.includes('/originals/model-miniatures/')) {
      imgUrl = imgUrl.replace('.png', '.webp');
    }
    if (!options.skipCloudfront) {
      // For now don't use cloudfront for cerokm images
      imgUrl = imgUrl.replace('https://rewise-images.s3.amazonaws.com', 'https://d1crblsfe59eq8.cloudfront.net');
    }
  }

  // Use cloudfront instead of directly using s3, as it supports http2 and is faster
  return imgUrl.replace(/\/originals\/((?:[^/]+\/)+)([^/]+)$/, `/processed/$1${size}/$2`);
}

export const getImageThumbnailSmall = (imgUrl) => getImageThumbnail(imgUrl, 's');
export const getImageThumbnailMedium = (imgUrl) => getImageThumbnail(imgUrl, 'm');
export const getImageThumbnailLarge = (imgUrl) => getImageThumbnail(imgUrl, 'l');
